import React from 'react'
import Arabic from './components/Ar/Arabic'
import English from './components/Eng/English'
import {BrowserRouter as Router,Routes,Route} from "react-router-dom";

const App = () => {
  return (    
      <Router>
        <Routes>
          <Route path='/' element={<Arabic />} />
          <Route path='eng' element={<English />}/>
        </Routes>
      </Router>
  )
}

export default App